exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3qPlgzqUbTtwRbRARMLHxl .fxQXfZCYRsY3cs6jANJ-l ._2Cly7rOiTJxGH2_-oNo3dc{position:absolute}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_3qPlgzqUbTtwRbRARMLHxl",
	"lines-content": "fxQXfZCYRsY3cs6jANJ-l",
	"cdr": "_2Cly7rOiTJxGH2_-oNo3dc"
};